export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function money(cents) {
  return `$${(cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export const STATUS_LABELS = {
  pending_payment: "Pending Payment",
  paid: "Paid",
  received: "Received",
  grading: "In Grading",
  graded: "Graded",
  shipped: "Shipped",
  cancelled: "Cancelled",
};

export const STATUS_COLORS = {
  pending_payment: "text-amber-700 border-amber-300 bg-amber-50",
  paid: "text-[#0A0A0A] border-[#0A0A0A]/50 bg-[#0A0A0A]/10",
  received: "text-purple-700 border-purple-300 bg-purple-50",
  grading: "text-blue-700 border-blue-300 bg-blue-50",
  graded: "text-emerald-700 border-emerald-300 bg-emerald-50",
  shipped: "text-green-700 border-green-300 bg-green-50",
  cancelled: "text-red-700 border-red-300 bg-red-50",
};
